import { Component, Inject, OnInit } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConsultantComponent } from '../consultant.component';
import { ConsultantService } from '../consultant.service';
import { UntypedFormControl, Validators } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { Utils } from '../../../shared/utils';
import { SumasySaldosGroupAccountsModel } from '../../accounting/models/sumasysaldosGroup.model';
import { MonthModel } from '../../../shared/components/table/month.model';
import { months, monthsNumeric } from '../../../consts';
import { Option } from '../../../shared/models/option.model';

@Component({
    selector: 'app-convfact-consultant-dialog-accounting-reports',
    templateUrl: './consultant-dialog-accounting-reports.component.html',
    styleUrls: [],
    standalone: false
})

export class ConsultantDialogAccountingReportsComponent implements OnInit {

  public isLoading: boolean = false;

  public type: string = this.data.type;
  public usersUids: string[] = this.data.usersUids;
  public title: string = '';

  public fromFilterBalance: UntypedFormControl;
  public toFilterBalance: UntypedFormControl;
  public yearFilterBalance: UntypedFormControl;

  public levelAccounts: string = '1';
  public group: SumasySaldosGroupAccountsModel[] = [];
  public groups: string[] = [];

  public yearFilterOptions: Option[] = [
    { label: '2024', value: '2024' },
    { label: '2023', value: '2023' },
  ];

  public fromToFilterBalanceOptions: Option[] = [
    { label: 'Apertura', value: '0' },
    ...['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
      .map((m, i) => ({ label: m, value: (i + 1).toString() })),
    { label: 'Regularización', value: '13' },
    { label: 'Cierre', value: '14' },
  ];

  public levelAccountsOptions: Option[] = [
    { label: 'Cuentas auxiliares', value: '0' },
    { label: 'Nivel 1', value: '1' },
    { label: 'Nivel 2', value: '2' },
    { label: 'Nivel 3', value: '3' },
  ];

  public monthControl = new UntypedFormControl(monthsNumeric);
  public monthsSelected: string[];
  public monthList: MonthModel[] = [];
  public allMonthsSelected = false;

  constructor(
    public dialogRef: MatDialogRef<ConsultantComponent>,
    public consultantService: ConsultantService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public ngOnInit(): void {
    this.setDefaultValesFormControl();

    if (this.type === 'perdidasyganancias') {

      this.title = 'Balance de Perdidas y Ganancias';

    }

    if (this.type === 'balancepymes') {

      this.title = 'Balance de Pymes';

    }

    if (this.type === 'reports') {

      this.title = 'Informes';

    }

    if (this.type === 'balancesumasysaldos') {

      this.title = 'Balance Sumas y Saldos';

    }
  }

  private setMonths(): void {
    if (this.monthList.length === 0) {
      let i = 1;
      months.forEach(element => {
        const newMonth = new MonthModel();
        newMonth.name = element;
        newMonth.selected = true;
        newMonth.number = i.toString();
        this.monthList.push(newMonth);
        i += 1;
      });
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
    }
  }

  private setDefaultValesFormControl(): void {
    const actualDate: Date = new Date();
    let actualMonth: number = actualDate.getMonth(); // Month Zero based
    actualMonth++; // Month Zero based

    this.fromFilterBalance = new UntypedFormControl('0', [Validators.required]);
    this.toFilterBalance = new UntypedFormControl(actualMonth.toString(), [Validators.required]);

    this.yearFilterBalance = new UntypedFormControl('2024', [Validators.required]);

    for (let i = 0; i < 10; i++) {
      const temp = new SumasySaldosGroupAccountsModel();
      temp.checked = false;
      temp.group = i.toString();
      this.group.push(temp);
    }

    this.setMonths();
  }

  public changeLevelAccounts(value: string): void {
    this.levelAccounts = value;
  }

  public toggle(group: number, event: MatCheckboxChange): void {
    // 10 select all elements
    if (group === 10) {

      for (let i = 0; i < this.group.length; i++) {
        this.group[i].checked = event.checked;
      }

      return;
    }
  }

  public onSelectAll(event): void {
    if (event.checked) {
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      this.monthControl.setValue(monthsNumeric, { emitEvent: false });
      this.monthList.forEach(element => element.selected = true);
    } else {
      this.allMonthsSelected = false;
      this.monthsSelected = [];
      this.monthControl.setValue([], { emitEvent: false });
      this.monthList.forEach(element => element.selected = false);
    }
  }

  public getSelectedMonthsNames(): string {
    const selectedNames = this.monthsSelected.map(index => this.monthList[parseInt(index) - 1].name);
    return selectedNames.join(', ');
  }

  public download(): void {
    if (this.type === 'perdidasyganancias') {
      this.perdidasyganancias();
    }

    if (this.type === 'balancepymes') {
      this.balancepymes();
    }

    if (this.type === 'reports') {
      this.reports();
    }

    if (this.type === 'balancesumasysaldos') {
      this.balancesumasysaldos();
    }
  }

  private perdidasyganancias(): void {
    this.isLoading = true;

    const request = {
      from: this.fromFilterBalance.value,
      to: this.toFilterBalance.value,
      year: this.yearFilterBalance.value,
      global: true,
      usersUids: this.usersUids,
      levelAccounts: '',
      groups: '',
      monthsSelected: '',
    }

    this.consultantService.getExcelProfitAndLoss(request)
      .then(response => {

        this.isLoading = false;

        FileSaver.saveAs(response, Utils.GetExcelName("Pérdida y Ganancias Pymes"));
      })
      .catch(err => {

        this.isLoading = false;

      });
  }

  private balancepymes(): void {
    this.isLoading = true;

    const request = {
      from: this.fromFilterBalance.value,
      to: this.toFilterBalance.value,
      year: this.yearFilterBalance.value,
      global: true,
      usersUids: this.usersUids,
      levelAccounts: '',
      groups: '',
      monthsSelected: '',
    }

    this.consultantService.getExcelBalancePymes(request)
      .then(response => {

        this.isLoading = false;

        FileSaver.saveAs(response, Utils.GetExcelName("Balance Pymes"));
      })
      .catch(err => {

        this.isLoading = false;

      });
  }

  private balancesumasysaldos(): void {
    this.isLoading = true;

    const request = {
      from: this.fromFilterBalance.value,
      to: this.toFilterBalance.value,
      year: this.yearFilterBalance.value,
      global: true,
      usersUids: this.usersUids,
      levelAccounts: this.levelAccounts,
      groups: this.group,
      monthsSelected: '',
    }

    this.consultantService.getExcelBalanceSumasySaldos(request)
      .then(response => {

        this.isLoading = false;

        FileSaver.saveAs(response, Utils.GetExcelName("Balance Sumas y Saldos"));
      })
      .catch(err => {

        this.isLoading = false;

      });
  }

  private reports(): void {
    this.isLoading = true;

    const request = {
      from: this.fromFilterBalance.value,
      to: this.toFilterBalance.value,
      year: this.yearFilterBalance.value,
      global: true,
      usersUids: this.usersUids,
      levelAccounts: this.levelAccounts,
      groups: this.group,
      monthsSelected: this.monthsSelected,
    }

    this.consultantService.getExcelReports(request)
      .then(response => {

        this.isLoading = false;

        FileSaver.saveAs(response, Utils.GetExcelName("Informes"));
      })
      .catch(err => {

        this.isLoading = false;

      });
  }

  public trackByIndex(i: number) { return i; }

}
